// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1z9H6","modalFooterButton":"ModalNotes_modalFooterButton__2HzBz"};